/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef, useMemo } from "react";
import {
  accessAPI,
  evidenciasDeInteraccion,
  EvidenciasHallazgo,
  formatFecha,
  Sidebar,
  TablaFiltrable
} from "../../shared";
import ProductoEnActividad from "./pasoVerificacion/ProductoEnActividad.js";
import { Formulario } from "../../shared";
import PasoIngreso from "./pasoIngreso/PasoIngreso";
import PasoRevision from "./pasoRevision/PasoRevision";
import PasoVerificacion from "./pasoVerificacion/PasoVerificacion";
import FormularioProducto from "./pasoIngreso/FormularioProducto";
import AnalisisIA from "./AnalisisIA";
import { Titulo } from "../../shared";
import { Boton } from "../../shared";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Skeleton } from "primereact/skeleton";
import { CampoInformacion } from "../../shared";
import { Divider } from "primereact/divider";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Column } from "primereact/column";
import { Menu } from "primereact/menu";
import { Tag } from "primereact/tag";

import { useParams } from "react-router-dom";

export default function ActividadAbierta() {
  const [loader, setLoader] = useState(true);
  const [actividad, setActividad] = useState();
  const [formularioLoader, setFormularioLoader] = useState(false);
  const [decisiones, setDecisiones] = useState([]);
  const [archivos, setArchivos] = useState([]);
  // Último archivo movido desde un hallazgo, para sumarlo a la card de archivos
  const [archivoMovido, setArchivoMovido] = useState(null);
  const [formularioConfig, setFormularioConfig] = useState();
  const [comentarios, setComentarios] = useState();

  const [modoLectura, setModoLectura] = useState(false);

  const [sideBar, setSideBar] = useState(false);
  const [sideBarHallazgo, setSideBarHallazgo] = useState(false);
  const [hallazgoTipos, setHallazgoTipos] = useState([]);
  const [formLoaderHallazgo, setFormLoaderHallazgo] = useState(false);
  const [hallazgos, setHallazgos] = useState([]);
  const [hallazgoSeleccionado, setHallazgoSeleccionado] = useState(null);
  const [sideBarHallazgoDetalle, setSideBarHallazgoDetalle] = useState(false);
  const [sideBarHallazgoEditar, setSideBarHallazgoEditar] = useState(false);
  const [sideBarHallazgoInteraccion, setSideBarHallazgoInteraccion] =
    useState(false);
  const [formLoaderHallazgoEditar, setFormLoaderHallazgoEditar] =
    useState(false);
  const [formLoaderHallazgoInteraccion, setFormLoaderHallazgoInteraccion] =
    useState(false);
  const [sideBarEstado, setSideBarEstado] = useState(false);
  const [formLoaderEstado, setFormLoaderEstado] = useState(false);

  // Estado del Análisis de IA
  const [analisisIA, setAnalisisIA] = useState(null);
  const [sidebarAnalisisIA, setSidebarAnalisisIA] = useState(false);
  const [sidebarProductoIA, setSidebarProductoIA] = useState(false);
  const [propuestoIA, setPropuestoIA] = useState(null);
  const [formKeyProductoIA, setFormKeyProductoIA] = useState(0);
  const [loaderProcesarIA, setLoaderProcesarIA] = useState(false);

  const toast = useRef(null);
  const menuHallazgoRef = useRef(null);

  const { pasoId } = useParams();

  // Cuando carga el componente, va a buscar el paso de la actividad
  useEffect(() => {
    accessAPI(
      "GET",
      `colab/actividad/${pasoId}`,
      null,
      (respuesta) => {
        setActividad(respuesta);
        // Si recibió una decisiónn, la agrega al state
        for (const auditor of respuesta.actividadpaso_x_auditor) {
          if (auditor?.actividadpasodecision?.length) {
            setDecisiones((actual) => [
              ...actual.concat(auditor.actividadpasodecision)
            ]);
          }
        }

        // Si recibió archivos de la actividad, los agrega al state
        if (respuesta.actividad?.archivos) {
          setArchivos(respuesta.actividad.archivos);
        }

        // Si el paso no es el actual, lo marca como solo lectura
        if (!respuesta.actual) {
          setModoLectura(true);
        }

        setComentarios(respuesta.textoDecisionProvisorio);

        // Cargar hallazgos de la actividad
        if (respuesta.hallazgos) {
          setHallazgos(respuesta.hallazgos);
        }
      },
      (respuesta) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0].msg ||
            "Ocurrió un error, intente nuevamente más tarde.",
          sticky: true
        });
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Carga el Análisis de IA vigente del proceso (si existe)
  function cargarAnalisisIA(reabrirSidebar) {
    accessAPI(
      "GET",
      `colab/actividad/${pasoId}/analisis`,
      null,
      (respuesta) => {
        setAnalisisIA(respuesta);
        if (reabrirSidebar) setSidebarAnalisisIA(true);
      },
      () => setAnalisisIA(null)
    );
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => cargarAnalisisIA(false), [pasoId]);

  // Vuelca la conclusión de la IA al campo de comentarios del cierre de paso.
  function volcarConclusionIA(texto) {
    const bloque = `\n----------\nAnálisis de IA\n${texto}`;
    const nuevo = (comentarios || "") + bloque;
    setComentarios(nuevo);
    // Persiste el borrador para que no se pierda al cerrar
    accessAPI(
      "POST",
      `colab/actividad/${pasoId}/comentarioprovisorio`,
      { contenido: nuevo },
      () => {},
      () => {}
    );
    toast.current?.show({
      severity: "success",
      summary: "Listo",
      detail: "Conclusión agregada al cierre de paso",
      life: 3000
    });
  }

  // Abre el sidebar del producto precargado con los valores del propuesto.
  function abrirAgregarProductoIA(propuesto) {
    setPropuestoIA(propuesto);
    setSidebarAnalisisIA(false);
    setFormKeyProductoIA((k) => k + 1);
    setSidebarProductoIA(true);
  }

  // Tras crear el producto, marca el propuesto como agregado. Mantiene abierto
  // el formulario de producto (no vuelve al sidebar de IA) y refresca el
  // análisis en segundo plano para que el propuesto quede marcado como agregado.
  function onProductoIAAgregado(nuevoProducto) {
    accessAPI(
      "PUT",
      `colab/actividad/analisis/producto-propuesto/${propuestoIA?.id}/agregado`,
      { productoRealId: nuevoProducto?.id },
      () => cargarAnalisisIA(false),
      () => {}
    );
  }

  // Marca el análisis como procesado (cierra la revisión).
  function marcarProcesadoIA(analisisId) {
    setLoaderProcesarIA(true);
    accessAPI(
      "PUT",
      `colab/actividad/analisis/${analisisId}/procesado`,
      {},
      () => {
        setLoaderProcesarIA(false);
        setAnalisisIA((prev) => (prev ? { ...prev, procesado: true } : prev));
        toast.current?.show({
          severity: "success",
          summary: "Listo",
          detail: "Análisis marcado como procesado",
          life: 3000
        });
      },
      (respuesta) => {
        setLoaderProcesarIA(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "No se pudo marcar como procesado",
          sticky: true
        });
      }
    );
  }

  // Producto sintético (shape de FormularioProducto) a partir del propuesto.
  const propuestoSinteticoIA = propuestoIA
    ? {
        producto_x_productocampospropios: (propuestoIA.campos || []).map((c) => ({
          productocampospropios: { id: c.productocampospropiosid },
          valor: c.valor
        })),
        producto_x_productocaracteristicascriticas: (
          propuestoIA.caracteristicas || []
        ).map((c) => ({
          caracteristicacritica: { id: c.caracteristicacriticaid },
          valor: c.valor
        }))
      }
    : null;

  // Cargar tipos de hallazgo al montar
  useEffect(() => {
    accessAPI("GET", "colab/hallazgo/tipo", null, (respuesta) => {
      setHallazgoTipos(respuesta);
    });
  }, []);

  // Cuando termina de cargar la actividad, apaga el loader
  useEffect(() => {
    if (actividad) {
      setLoader(false);
    }
  }, [actividad]);

  // Función para crear hallazgo
  function crearHallazgo(contenidoCampos) {
    setFormLoaderHallazgo(true);
    accessAPI(
      "POST",
      "colab/hallazgo",
      {
        hallazgoTipoId: contenidoCampos.hallazgoTipoId,
        resumen: contenidoCampos.resumen,
        texto: contenidoCampos.texto,
        actividadId: actividad.actividad.id
      },
      (respuesta) => {
        toast.current.show({
          severity: "success",
          summary: "Éxito",
          detail: "Hallazgo creado correctamente",
          life: 3000
        });
        setHallazgos((actual) => [respuesta, ...actual]);
        setFormLoaderHallazgo(false);
        setSideBarHallazgo(false);
      },
      (respuesta) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg ||
            "Ocurrió un error, intente nuevamente más tarde.",
          sticky: true
        });
        setFormLoaderHallazgo(false);
      }
    );
  }

  // Función para enviar decisión de aprobación o rechazo
  function enviarDecision(contenidoCampos, aprobado) {
    setFormularioLoader(true);

    const decisionData = {
      comentarios: contenidoCampos.comentarios || "",
      aprobado: aprobado
    };

    accessAPI(
      "PUT",
      `colab/actividad/decisionpaso/${pasoId}`,
      decisionData,
      (respuesta) => {
        toast.current.show({
          severity: "success",
          summary: "Éxito",
          detail: "Decisión enviada correctamente",
          life: 3000
        });
        setDecisiones((actual) => [...decisiones, respuesta]);
        setFormularioLoader(false);
        setModoLectura(true);
        setSideBar(false);
      },
      (respuesta) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0].msg ||
            "Ocurrió un error, intente nuevamente más tarde.",
          sticky: true
        });
        setFormularioLoader(false);
      }
    );
  }

  // Función para el botón Aceptar
  function aceptarActividad(contenidoCampos) {
    enviarDecision(contenidoCampos, true);
  }

  // Función para el botón Rechazar
  function rechazarActividad(contenidoCampos) {
    enviarDecision(contenidoCampos, false);
  }

  // Función para agregar comentario de estado
  function agregarEstado(contenidoCampos) {
    setFormLoaderEstado(true);
    accessAPI(
      "PUT",
      `colab/actividad/${actividad.id}/estado`,
      { comentarioStatus: contenidoCampos.comentarioStatus },
      (respuesta) => {
        // Actualiza el estado local para que el formulario cargue las notas
        // vigentes la próxima vez que se abra el sidebar
        setActividad((prev) => ({
          ...prev,
          comentarioStatus: contenidoCampos.comentarioStatus
        }));
        toast.current.show({
          severity: "success",
          summary: "Éxito",
          detail: "Estado actualizado correctamente",
          life: 3000
        });
        setFormLoaderEstado(false);
        setSideBarEstado(false);
      },
      (respuesta) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg ||
            "Ocurrió un error, intente nuevamente más tarde.",
          sticky: true
        });
        setFormLoaderEstado(false);
      }
    );
  }

  // Función para editar hallazgo
  function editarHallazgo(contenidoCampos) {
    setFormLoaderHallazgoEditar(true);
    accessAPI(
      "PUT",
      `colab/hallazgo/${hallazgoSeleccionado.id}`,
      {
        hallazgoTipoId: contenidoCampos.hallazgoTipoId,
        resumen: contenidoCampos.resumen,
        texto: contenidoCampos.texto
      },
      (respuesta) => {
        toast.current.show({
          severity: "success",
          summary: "Éxito",
          detail: "Hallazgo actualizado correctamente",
          life: 3000
        });
        setHallazgos((actual) =>
          actual.map((h) => (h.id === respuesta.id ? respuesta : h))
        );
        setFormLoaderHallazgoEditar(false);
        setSideBarHallazgoEditar(false);
      },
      (respuesta) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg ||
            "Ocurrió un error, intente nuevamente más tarde.",
          sticky: true
        });
        setFormLoaderHallazgoEditar(false);
      }
    );
  }

  // Función para enviar interacción
  function enviarInteraccion(contenidoCampos, archivo) {
    setFormLoaderHallazgoInteraccion(true);
    accessAPI(
      "PUT",
      `colab/hallazgo/${hallazgoSeleccionado.id}/interaccion`,
      { contenido: contenidoCampos.contenido },
      (respuesta) => {
        toast.current.show({
          severity: "success",
          summary: "Éxito",
          detail: "Comentario enviado correctamente",
          life: 3000
        });
        setHallazgos((actual) =>
          actual.map((h) => (h.id === respuesta.id ? respuesta : h))
        );
        setHallazgoSeleccionado(respuesta);
        setFormLoaderHallazgoInteraccion(false);
      },
      (respuesta) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg ||
            "Ocurrió un error, intente nuevamente más tarde.",
          sticky: true
        });
        setFormLoaderHallazgoInteraccion(false);
      },
      archivo
    );
  }

  // Función para cerrar hallazgo
  function cerrarHallazgo(contenidoCampos, archivo) {
    setFormLoaderHallazgoInteraccion(true);
    accessAPI(
      "PUT",
      `colab/hallazgo/${hallazgoSeleccionado.id}/cerrar`,
      { contenido: contenidoCampos.contenido },
      (respuesta) => {
        toast.current.show({
          severity: "success",
          summary: "Éxito",
          detail: "Hallazgo cerrado correctamente",
          life: 3000
        });
        setHallazgos((actual) =>
          actual.map((h) => (h.id === respuesta.id ? respuesta : h))
        );
        setFormLoaderHallazgoInteraccion(false);
        setSideBarHallazgoInteraccion(false);
      },
      (respuesta) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg ||
            "Ocurrió un error, intente nuevamente más tarde.",
          sticky: true
        });
        setFormLoaderHallazgoInteraccion(false);
      },
      archivo
    );
  }

  // Menú contextual del hallazgo: cerrado, solo ver sus detalles; abierto,
  // la interacción y, mientras nadie haya interactuado (el cliente todavía no
  // respondió), editarlo
  const menuHallazgoItems = useMemo(() => {
    if (!hallazgoSeleccionado) return [];
    if (hallazgoSeleccionado.fechaCierre) {
      return [
        {
          label: "Ver detalles",
          icon: "pi pi-eye",
          command: () => setSideBarHallazgoDetalle(true)
        }
      ];
    }
    const items = [];
    if (!hallazgoSeleccionado.interacciones?.length) {
      items.push({
        label: "Editar",
        icon: "pi pi-pencil",
        command: () => setSideBarHallazgoEditar(true)
      });
    }
    items.push({
      label: "Interacción",
      icon: "pi pi-comments",
      command: () => setSideBarHallazgoInteraccion(true)
    });
    return items;
  }, [hallazgoSeleccionado]);

  // Body para columna de acciones en DataTable de hallazgos
  function accionesHallazgo(rowData) {
    return (
      <Boton
        texto
        negro
        callback={(e) => {
          setHallazgoSeleccionado(rowData);
          menuHallazgoRef.current.toggle(e);
        }}
      >
        <i className="pi pi-ellipsis-v"></i>
      </Boton>
    );
  }

  // Necesito hacer este tejemaneje para que el formulario prserve el contenido de los campos al abrir y cerrar el modal. Además, el contenido del campo se carga desde la API inicialmente.
  useEffect(() => {
    if (formularioConfig) {
      setSideBar(true);
    } else {
      setSideBar(false);
    }
  }, [formularioConfig]);

  // Memoizar componentes pesados para evitar re-renders cuando cambia el estado comentarios
  const pasoIngresoMemo = useMemo(() => {
    if (actividad?.pasoTipo?.id === 1) {
      return (
        <PasoIngreso
          actividad={actividad.actividad}
          pasoId={actividad.id}
          archivosPaso={archivos}
          archivoAgregado={archivoMovido}
          paso={actividad}
          modoLectura={modoLectura}
        />
      );
    }
    return null;
  }, [actividad, archivos, archivoMovido, modoLectura]);

  const pasoRevisionMemo = useMemo(() => {
    if (actividad?.pasoTipo?.id === 2) {
      return (
        <PasoRevision
          actividad={actividad.actividad}
          pasoId={actividad.id}
          archivosPaso={archivos}
          archivoAgregado={archivoMovido}
          paso={actividad}
          modoLectura={modoLectura}
        />
      );
    }
    return null;
  }, [actividad, archivos, archivoMovido, modoLectura]);

  const pasoVerificacionMemo = useMemo(() => {
    if (actividad?.pasoTipo?.id === 3) {
      return (
        <PasoVerificacion
          actividad={actividad.actividad}
          pasoActual={actividad.id}
          archivosPaso={archivos}
          archivoAgregado={archivoMovido}
          paso={actividad}
          modoLectura={modoLectura}
        />
      );
    }
    return null;
  }, [actividad, archivos, archivoMovido, modoLectura]);

  const productosListMemo = useMemo(() => {
    if (
      actividad &&
      ![1, 2, 3].includes(actividad.pasoTipo?.id)
    ) {
      return (
        <>
          <h1>
            <i className="pi pi-box" css={{ marginRight: "0.5em" }}></i>
            Productos
          </h1>
          {actividad.actividad.proceso.producto.map((producto) => {
            return (
              <ProductoEnActividad
                key={producto.id}
                producto={producto}
                pasoId={actividad.id}
              />
            );
          })}
        </>
      );
    }
    return null;
  }, [actividad]);

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <ConfirmDialog />
      {loader && (
        <div>
          {/* Skeleton del título */}
          <div
            css={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "2em",
              marginBottom: "1em"
            }}
          >
            <Skeleton width="20rem" height="2rem" />
            <Skeleton width="8rem" height="2.5rem" />
          </div>

          {/* Skeleton de detalles del proceso */}
          <Card css={{ marginBottom: "1em" }}>
            <div
              css={{
                display: "flex",
                alignItems: "center",
                marginBottom: "1rem"
              }}
            >
              <Skeleton
                shape="circle"
                size="1.5rem"
                css={{ marginRight: "0.5em" }}
              />
              <Skeleton width="14rem" height="1.5rem" />
            </div>
            <div className="grid">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div className="col-12 md:col-6" key={i}>
                  <Skeleton
                    width="8rem"
                    height="0.9rem"
                    css={{ marginBottom: "0.3rem" }}
                  />
                  <Skeleton width="12rem" height="1.1rem" />
                </div>
              ))}
            </div>
          </Card>

          {/* Skeleton del contenido del paso */}
          <Card css={{ marginBottom: "1em" }}>
            <div
              css={{
                display: "flex",
                alignItems: "center",
                marginBottom: "1rem"
              }}
            >
              <Skeleton
                shape="circle"
                size="1.5rem"
                css={{ marginRight: "0.5em" }}
              />
              <Skeleton width="10rem" height="1.5rem" />
            </div>
            <div
              css={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}
            >
              {[1, 2, 3].map((i) => (
                <Skeleton key={i} width="100%" height="3rem" />
              ))}
            </div>
          </Card>

          {/* Skeleton de productos */}

          <div className="grid">
            {[1, 2].map((i) => (
              <div className="col-12 md:col-6" key={i}>
                <Card>
                  <Skeleton
                    width="70%"
                    height="1.2rem"
                    css={{ marginBottom: "0.5rem" }}
                  />
                  <Skeleton
                    width="50%"
                    height="1rem"
                    css={{ marginBottom: "1rem" }}
                  />
                  <Skeleton width="100%" height="2rem" />
                </Card>
              </div>
            ))}
          </div>
        </div>
      )}
      {!loader && actividad && (
        <div css={{ position: "relative" }}>
          <Sidebar
            visible={sideBar}
            onHide={() => setFormularioConfig()}
            position="right"
            closeIcon={
              <div>
                <i className="pi pi-times"></i>
              </div>
            }
            className="w-full lg:w-30rem md:w-30rem"
          >
            <div css={{ marginBottom: "50px" }}>
              <Titulo>Cerrar paso</Titulo>
              <Formulario config={formularioConfig} loader={formularioLoader} />
            </div>
          </Sidebar>

          {/* Sidebar Análisis de IA */}
          <Sidebar
            visible={sidebarAnalisisIA}
            onHide={() => setSidebarAnalisisIA(false)}
            position="right"
            className="w-full lg:w-8"
          >
            <AnalisisIA
              analisis={analisisIA}
              pasoId={pasoId}
              proceso={actividad?.actividad?.proceso}
              modoLectura={modoLectura}
              loaderProcesar={loaderProcesarIA}
              onVolcarConclusion={volcarConclusionIA}
              onAgregarProducto={abrirAgregarProductoIA}
              onMarcarProcesado={marcarProcesadoIA}
            />
          </Sidebar>

          {/* Sidebar Producto desde IA (precargado) */}
          <Sidebar
            visible={sidebarProductoIA}
            onHide={() => {
              setSidebarProductoIA(false);
              setSidebarAnalisisIA(true);
            }}
            position="right"
            className="w-full lg:w-30rem md:w-30rem"
          >
            {actividad?.actividad?.proceso && (
              <FormularioProducto
                proceso={actividad.actividad.proceso}
                pasoId={pasoId}
                modoEdicion={false}
                productoSeleccionado={propuestoSinteticoIA}
                agregarProductoAProceso={onProductoIAAgregado}
                actualizarProductoEnLista={() => {}}
                formularioKey={formKeyProductoIA}
              />
            )}
          </Sidebar>

          <Sidebar
            visible={sideBarHallazgo}
            onHide={() => setSideBarHallazgo(false)}
            position="right"
            closeIcon={
              <div>
                <i className="pi pi-times"></i>
              </div>
            }
            className="w-full lg:w-30rem md:w-30rem"
          >
            <div css={{ marginBottom: "50px" }}>
              <Titulo>Nuevo hallazgo</Titulo>
              <Formulario
                config={{
                  secciones: [
                    {
                      campos: [
                        {
                          nombre: "hallazgoTipoId",
                          etiqueta: "Tipo de hallazgo",
                          tipoitemformularioid: 5, // dropdown
                          opciones: hallazgoTipos,
                          sinOpcionInicial: true,
                          requerido: true
                        },
                        {
                          nombre: "resumen",
                          etiqueta: "Resumen",
                          tipoitemformularioid: 1,
                          requerido: true,
                          notas: "No más de 3 o 4 palabras"
                        },
                        {
                          nombre: "texto",
                          etiqueta: "Texto",
                          tipoitemformularioid: 11, // textarea
                          requerido: true
                        }
                      ]
                    }
                  ],
                  botones: [
                    {
                      etiqueta: "Crear hallazgo",
                      callback: crearHallazgo,
                      validar: true
                    }
                  ]
                }}
                loader={formLoaderHallazgo}
              />
            </div>
          </Sidebar>
          {/* Sidebar detalle hallazgo */}
          <Sidebar
            visible={sideBarHallazgoDetalle}
            onHide={() => setSideBarHallazgoDetalle(false)}
            position="right"
            closeIcon={
              <div>
                <i className="pi pi-times"></i>
              </div>
            }
            className="w-full lg:w-30rem md:w-30rem"
          >
            {hallazgoSeleccionado && (
              <div css={{ marginBottom: "50px" }}>
                <Titulo>Detalles del hallazgo</Titulo>
                <div className="grid">
                  <CampoInformacion nombreCampo="Tipo">
                    {hallazgoSeleccionado.hallazgoTipo?.nombre}
                  </CampoInformacion>
                  <CampoInformacion nombreCampo="Resumen">
                    {hallazgoSeleccionado.resumen}
                  </CampoInformacion>
                  <CampoInformacion nombreCampo="Texto" anchoCompleto>
                    {hallazgoSeleccionado.texto}
                  </CampoInformacion>
                  <CampoInformacion nombreCampo="Auditor creador">
                    {hallazgoSeleccionado.auditorCreador?.nombre}{" "}
                    {hallazgoSeleccionado.auditorCreador?.apellido}
                  </CampoInformacion>
                  <CampoInformacion nombreCampo="Fecha de creación">
                    {hallazgoSeleccionado.fechaCreacion &&
                      formatFecha(hallazgoSeleccionado.fechaCreacion)}
                  </CampoInformacion>
                  {hallazgoSeleccionado.fechaCierre && (
                    <CampoInformacion nombreCampo="Fecha de cierre">
                      {formatFecha(hallazgoSeleccionado.fechaCierre)}
                    </CampoInformacion>
                  )}
                </div>
                {hallazgoSeleccionado.interacciones?.length > 0 && (
                  <>
                    <Divider />
                    <Titulo>Interacciones</Titulo>
                    {hallazgoSeleccionado.interacciones.map(
                      (interaccion, idx) => (
                        <div
                          key={idx}
                          css={{
                            padding: "0.75em",
                            marginBottom: "0.5em",
                            borderRadius: "6px",
                            backgroundColor: interaccion.cierre ? "#f0fdf4" : "#f8f9fa",
                            border: interaccion.cierre ? "1px solid #16a34a" : "1px solid #dee2e6"
                          }}
                        >
                          <div
                            css={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "0.5em"
                            }}
                          >
                            <span css={{ fontWeight: "bold", fontSize: "0.9em", display: "flex", alignItems: "center", gap: "0.4em" }}>
                              {interaccion.cierre && (
                                <i className="pi pi-check-circle" css={{ color: "#16a34a" }}></i>
                              )}
                              {interaccion.usuario}
                            </span>
                            <div css={{ display: "flex", gap: "0.5em", alignItems: "center" }}>
                              {interaccion.colaborador && (
                                <Tag
                                  value="Colaborador"
                                  severity="info"
                                  css={{ fontSize: "0.7em" }}
                                />
                              )}
                              {interaccion.cliente && (
                                <Tag
                                  value="Cliente"
                                  severity="success"
                                  css={{ fontSize: "0.7em" }}
                                />
                              )}
                              {interaccion.admin && (
                                <Tag
                                  value="Admin"
                                  severity="warning"
                                  css={{ fontSize: "0.7em" }}
                                />
                              )}
                              <span css={{ fontSize: "0.8em", color: "#6c757d" }}>
                                {formatFecha(interaccion.fecha)}
                              </span>
                            </div>
                          </div>
                          {interaccion.textos?.map((texto, tIdx) => (
                            <div key={tIdx} css={{ marginBottom: "0.25em" }}>
                              <span
                                css={{
                                  fontSize: "0.8em",
                                  color: "#6c757d",
                                  fontWeight: "600"
                                }}
                              >
                                {texto.nombre}:
                              </span>
                              <p
                                css={{
                                  margin: "0.2em 0 0 0",
                                  fontSize: "0.9em",
                                  whiteSpace: "pre-wrap"
                                }}
                              >
                                {texto.contenido}
                              </p>
                            </div>
                          ))}
                          {evidenciasDeInteraccion(interaccion).length > 0 && (
                            <EvidenciasHallazgo
                              rutaBase="colab/hallazgo"
                              hallazgoId={hallazgoSeleccionado.id}
                              evidencias={evidenciasDeInteraccion(interaccion)}
                              idsEnActividad={archivos.map((a) => a.id)}
                              puedeMover={!modoLectura}
                              onMovido={(archivo) => {
                                setArchivos((actual) => [...actual, archivo]);
                                setArchivoMovido(archivo);
                              }}
                              toast={toast}
                            />
                          )}
                        </div>
                      )
                    )}
                  </>
                )}
              </div>
            )}
          </Sidebar>
          {/* Sidebar editar hallazgo */}
          <Sidebar
            visible={sideBarHallazgoEditar}
            onHide={() => setSideBarHallazgoEditar(false)}
            position="right"
            closeIcon={
              <div>
                <i className="pi pi-times"></i>
              </div>
            }
            className="w-full lg:w-30rem md:w-30rem"
          >
            {hallazgoSeleccionado && (
              <div css={{ marginBottom: "50px" }}>
                <Titulo>Editar hallazgo</Titulo>
                <Formulario
                  config={{
                    secciones: [
                      {
                        campos: [
                          {
                            nombre: "hallazgoTipoId",
                            etiqueta: "Tipo de hallazgo",
                            tipoitemformularioid: 5,
                            opciones: hallazgoTipos,
                            requerido: true,
                            respuesta: hallazgoSeleccionado.hallazgoTipo?.nombre
                              ? hallazgoTipos.find(
                                  (t) =>
                                    t.etiqueta ===
                                    hallazgoSeleccionado.hallazgoTipo.nombre
                                )?.value
                              : null
                          },
                          {
                            nombre: "resumen",
                            etiqueta: "Resumen",
                            tipoitemformularioid: 1,
                            requerido: true,
                            notas: "No más de 3 o 4 palabras",
                            respuesta: hallazgoSeleccionado.resumen
                          },
                          {
                            nombre: "texto",
                            etiqueta: "Texto",
                            tipoitemformularioid: 11,
                            requerido: true,
                            respuesta: hallazgoSeleccionado.texto
                          }
                        ]
                      }
                    ],
                    botones: [
                      {
                        etiqueta: "Guardar",
                        callback: editarHallazgo
                      }
                    ]
                  }}
                  loader={formLoaderHallazgoEditar}
                />
              </div>
            )}
          </Sidebar>
          {/* Sidebar interacción hallazgo */}
          <Sidebar
            visible={sideBarHallazgoInteraccion}
            onHide={() => setSideBarHallazgoInteraccion(false)}
            position="right"
            closeIcon={
              <div>
                <i className="pi pi-times"></i>
              </div>
            }
            className="w-full lg:w-30rem md:w-30rem"
          >
            {hallazgoSeleccionado && (
              <div css={{ marginBottom: "50px" }}>
                <Titulo>Interacción</Titulo>
                <div className="grid">
                  <CampoInformacion nombreCampo="Tipo">
                    {hallazgoSeleccionado.hallazgoTipo?.nombre}
                  </CampoInformacion>
                  <CampoInformacion nombreCampo="Resumen">
                    {hallazgoSeleccionado.resumen}
                  </CampoInformacion>
                  <CampoInformacion nombreCampo="Texto" anchoCompleto>
                    {hallazgoSeleccionado.texto}
                  </CampoInformacion>
                </div>
                <Divider />
                {/* Lista de interacciones existentes */}
                {hallazgoSeleccionado.interacciones?.length > 0 && (
                  <div css={{ marginBottom: "1em" }}>
                    {hallazgoSeleccionado.interacciones.map(
                      (interaccion, idx) => (
                        <div
                          key={idx}
                          css={{
                            padding: "0.75em",
                            marginBottom: "0.5em",
                            borderRadius: "6px",
                            backgroundColor: interaccion.cierre ? "#f0fdf4" : "#f8f9fa",
                            border: interaccion.cierre ? "1px solid #16a34a" : "1px solid #dee2e6"
                          }}
                        >
                          <div
                            css={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "0.5em"
                            }}
                          >
                            <span css={{ fontWeight: "bold", fontSize: "0.9em", display: "flex", alignItems: "center", gap: "0.4em" }}>
                              {interaccion.cierre && (
                                <i className="pi pi-check-circle" css={{ color: "#16a34a" }}></i>
                              )}
                              {interaccion.usuario}
                            </span>
                            <div css={{ display: "flex", gap: "0.5em", alignItems: "center" }}>
                              {interaccion.colaborador && (
                                <Tag
                                  value="Colaborador"
                                  severity="info"
                                  css={{ fontSize: "0.7em" }}
                                />
                              )}
                              {interaccion.cliente && (
                                <Tag
                                  value="Cliente"
                                  severity="success"
                                  css={{ fontSize: "0.7em" }}
                                />
                              )}
                              {interaccion.admin && (
                                <Tag
                                  value="Admin"
                                  severity="warning"
                                  css={{ fontSize: "0.7em" }}
                                />
                              )}
                              <span css={{ fontSize: "0.8em", color: "#6c757d" }}>
                                {formatFecha(interaccion.fecha)}
                              </span>
                            </div>
                          </div>
                          {interaccion.textos?.map((texto, tIdx) => (
                            <div key={tIdx} css={{ marginBottom: "0.25em" }}>
                              <span
                                css={{
                                  fontSize: "0.8em",
                                  color: "#6c757d",
                                  fontWeight: "600"
                                }}
                              >
                                {texto.nombre}:
                              </span>
                              <p
                                css={{
                                  margin: "0.2em 0 0 0",
                                  fontSize: "0.9em",
                                  whiteSpace: "pre-wrap"
                                }}
                              >
                                {texto.contenido}
                              </p>
                            </div>
                          ))}
                          {evidenciasDeInteraccion(interaccion).length > 0 && (
                            <EvidenciasHallazgo
                              rutaBase="colab/hallazgo"
                              hallazgoId={hallazgoSeleccionado.id}
                              evidencias={evidenciasDeInteraccion(interaccion)}
                              idsEnActividad={archivos.map((a) => a.id)}
                              puedeMover={!modoLectura}
                              onMovido={(archivo) => {
                                setArchivos((actual) => [...actual, archivo]);
                                setArchivoMovido(archivo);
                              }}
                              toast={toast}
                            />
                          )}
                        </div>
                      )
                    )}
                  </div>
                )}
                <Divider />
                <Formulario
                  config={{
                    secciones: [
                      {
                        campos: [
                          {
                            nombre: "contenido",
                            etiqueta: "Comentario",
                            tipoitemformularioid: 11,
                            requerido: true
                          },
                          {
                            nombre: "evidencia",
                            etiqueta: "Evidencia",
                            tipoitemformularioid: 10
                          }
                        ]
                      }
                    ],
                    botones: [
                      {
                        etiqueta: "Enviar comentario",
                        callback: enviarInteraccion,
                        transparente: true,
                        validar: true
                      },
                      {
                        etiqueta: "Cerrar hallazgo",
                        callback: cerrarHallazgo,
                        confirmacion:
                          "Esta acción cerrará el hallazgo, ¿seguro?",
                        rojo: true,
                        validar: true
                      }
                    ]
                  }}
                  loader={formLoaderHallazgoInteraccion}
                />
              </div>
            )}
          </Sidebar>
          <Sidebar
            visible={sideBarEstado}
            onHide={() => setSideBarEstado(false)}
            position="right"
            closeIcon={
              <div>
                <i className="pi pi-times"></i>
              </div>
            }
            className="w-full lg:w-30rem md:w-30rem"
          >
            <div css={{ marginBottom: "50px" }}>
              <Titulo>Agregar estado</Titulo>
              <Formulario
                config={{
                  secciones: [
                    {
                      campos: [
                        {
                          nombre: "comentarioStatus",
                          etiqueta: "Estado",
                          tipoitemformularioid: 11,
                          requerido: true,
                          respuesta: actividad?.comentarioStatus
                        }
                      ]
                    }
                  ],
                  botones: [
                    {
                      etiqueta: "Guardar estado",
                      callback: agregarEstado,
                      validar: true
                    }
                  ]
                }}
                loader={formLoaderEstado}
              />
            </div>
          </Sidebar>
          <Menu
            model={menuHallazgoItems}
            popup
            ref={menuHallazgoRef}
            popupAlignment="right"
          />
          <Titulo
            urlVolver="/"
            subtitulo={`Proceso ${actividad.actividad.proceso.nombre} - ${actividad.actividad.actividadtipo.nombre}`}
            etiqueta={actividad.enFormacion ? "En formación" : undefined}
            alerta={actividad.enFormacion}
            botones={
              <>
                {analisisIA && (
                  <Boton
                    azul
                    transparente
                    callback={() => setSidebarAnalisisIA(true)}
                  >
                    <i className="pi pi-sparkles" /> Análisis de IA
                  </Boton>
                )}
                {!modoLectura && (
                  <>
                    {hallazgoTipos.length > 0 && (
                      <Boton
                        rojo
                        transparente
                        callback={() => setSideBarHallazgo(true)}
                      >
                        Nuevo hallazgo
                      </Boton>
                    )}
                  <Boton
                    callback={() => {
                      setFormularioConfig({
                        secciones: [
                          {
                            campos: [
                              {
                                nombre: "comentarios",
                                etiqueta: `Comentarios`,
                                tipoitemformularioid: 11, // textarea
                                requerido: false,
                                onChangeRequestURL: `colab/actividad/${actividad.id}/comentarioprovisorio`,
                                respuesta: comentarios,
                                onChange: setComentarios
                              }
                            ]
                          }
                        ],
                        botones: [
                          {
                            etiqueta: "Rechazar",
                            callback: rechazarActividad,
                            validar: false,
                            confirmacion: "Esta acción cerrará el paso, ¿seguro?",
                            transparente: true
                          },
                          {
                            etiqueta: "Aprobar",
                            callback: aceptarActividad,
                            validar: false,
                            confirmacion: "Esta acción cerrará el paso, ¿seguro?"
                          }
                        ]
                      });
                    }}
                    menu={[
                      {
                        etiqueta: "Agregar estado",
                        icono: "pi pi-info-circle",
                        callback: () => setSideBarEstado(true)
                      }
                    ]}
                  >
                    Cerrar paso
                  </Boton>
                  </>
                )}
              </>
            }
          >
            {actividad.actividad.proceso.nombrefantasia}
          </Titulo>

          <Card css={{ marginBottom: "1em" }}>
            <Titulo>
              <i
                className="pi pi-info-circle"
                css={{ marginRight: "0.5em" }}
              ></i>
              Detalles del proceso
            </Titulo>
            <div className="grid">
              <CampoInformacion nombreCampo="Cliente">
                {actividad.actividad.proceso.cliente?.razonsocial}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Paso">
                {actividad.nombre}
              </CampoInformacion>
            </div>
            <Divider />
            <div className="grid">
              <CampoInformacion nombreCampo="Tipo de certificado">
                {actividad.actividad.proceso.certificadotipo?.nombre}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Norma">
                {actividad.actividad.proceso.norma?.numero}
                {actividad.actividad.proceso.norma?.ano &&
                  `:${actividad.actividad.proceso.norma.ano}`}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Reglamentación">
                {actividad.actividad.proceso.certificadotipo?.reglamentacion}
              </CampoInformacion>
            </div>
            <Divider />
            <div className="grid">
              {actividad.actividad.proceso.sitioFabrica?.nombre && (
                <CampoInformacion nombreCampo="Fábrica">
                  {actividad.actividad.proceso.sitioFabrica.nombre}
                </CampoInformacion>
              )}
              {actividad.actividad.proceso.sitioFabrica?.direccion && (
                <CampoInformacion nombreCampo="Dirección de la fábrica">
                  {actividad.actividad.proceso.sitioFabrica.direccion}
                </CampoInformacion>
              )}
              {actividad.actividad.proceso.sitioFabricante?.nombre && (
                <CampoInformacion nombreCampo="Fabricante">
                  {actividad.actividad.proceso.sitioFabricante.nombre}
                </CampoInformacion>
              )}
              {actividad.actividad.proceso.sitioFabricante?.direccion && (
                <CampoInformacion nombreCampo="Dirección del fabricante">
                  {actividad.actividad.proceso.sitioFabricante.direccion}
                </CampoInformacion>
              )}
            </div>
          </Card>

          {/* Hallazgos */}
          {hallazgos.length > 0 && <Card css={{ marginBottom: "1em" }}>
            <Titulo>
              <i
                className="pi pi-exclamation-triangle"
                css={{ marginRight: "0.5em" }}
              ></i>
              Hallazgos
            </Titulo>
            <TablaFiltrable conFiltros={false}
              value={hallazgos}
              emptyMessage="No hay hallazgos"
              size="small"
            >
              <Column field="resumen" header="Resumen" />
              <Column
                header="Tipo"
                body={(rowData) => (
                  <span css={{ display: "flex", alignItems: "center", gap: "0.5em" }}>
                    {rowData.hallazgoTipo?.nombre}
                    {!rowData.fechaCierre && (
                      <Tag value="Abierto" severity="danger" css={{ fontSize: "0.7em" }} />
                    )}
                  </span>
                )}
              />
              <Column
                body={accionesHallazgo}
                style={{ width: "3em" }}
              />
            </TablaFiltrable>
          </Card>}

          {/* Paso de ingreso */}
          {pasoIngresoMemo}

          {/* Paso de revisión */}
          {pasoRevisionMemo}

          {/* Paso de verificación */}
          {pasoVerificacionMemo}

          {/* PASO DE REVISIÓN: NO mostrar productos (solo decisión más abajo) */}
          {actividad.pasoTipo?.nombre === 2 && (
            <div className="tarjeta tresCuartos">
              <p>
                Revisa la documentación del proceso y luego aprueba o rechaza el
                paso.
              </p>
            </div>
          )}

          {/* OTROS PASOS (Inspecciones): Mostrar sistema de verificación campo por campo */}
          {productosListMemo}
        </div>
      )}
    </>
  );
}
